///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import messages from "../helpers/messages";

import Modal from "./Modal";

export const SystemErrorModal = ({
  open,
  large,
  closeModal,
  handleExit,
  handleTryAgain
}) => (
  <Modal
    title={messages.systemError.defaultMessage}
    open={open}
    large={large}
    handleClose={closeModal}
    titleClass="modal__title_light uppercase"
    bodyClass="border-top-grey px-24 pt-24"
    closeButtonClass="modal__close-button mr-16 mt-16"
  >
    <p
      data-testid="system-error-modal"
      className="font-size-16 text-dim-grey pb-8"
    >
      {messages.systemErrorMessage.defaultMessage}
    </p>
    <div className="grid fr">
      <div className="grid__cell pr-8">
        <button
          data-testid="exit-button"
          className="secondary-button one-whole cursor-pointer univers-67-bold-cond"
          onClick={handleExit}
        >
          {messages.exit.defaultMessage}
        </button>
      </div>
      <div className="grid__cell pl-8">
        <button
          data-testid="try-again-button"
          className="primary-button one-whole cursor-pointer univers-67-bold-cond"
          onClick={handleTryAgain}
        >
          {messages.tryAgain.defaultMessage}
        </button>
      </div>
    </div>
  </Modal>
);

export default SystemErrorModal;
